<template>
    <el-row v-if="linkPage">
        <div class="block" >
            <el-pagination 
            :current-page="linkPage.currentPage" 
            :page-sizes="pageSizes" 
            :page-size="linkPage.perPage" 
            :total="linkPage.totalCount"
            :page-count="linkPage.pageCount"
            layout="total, sizes, prev, pager, next, jumper" 
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            ></el-pagination>
        </div>
    </el-row>
</template>
  
<script>
export default {
    name: "MyPagination",
    props: {
        linkPage: {
            default: null,
            type: Object
        },
        pageSizes: {
            type: Array,
            default: function () {
                return [10, 20, 30, 50, 100];
            }
        },
    },
    created: function () {
    },
    methods: {
        handleSizeChange(newSize) {
            this.$emit('size-change', newSize);
        },
        handleCurrentChange(newPage) {
            this.$emit('current-change', newPage);
        }
    }
};
</script>
  


// WEBPACK FOOTER //
// src/widgets/MyPagination.vue